export default __webpack_public_path__ + "e891b22895cfce600e61f6ecdca565b0.png";